export default {"src":"/_next/static/media/Translate.513234d1.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};